import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";
import Select from "../../components/Select";

const selectOption = [
  "-- select package --",
  "Package 250 TRX",
  "Package 500 TRX",
  "Package 1000 TRX",
  "Package 5000 TRX",
  "Package 10000 TRX",
  "Package 50000 TRX",
  "Package 100000 TRX",
];

const AccountTopupPage = () => {
  const [data, setData] = useState({
    userId: "",
    package: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  return (
    <div className="mono_topupaccount_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_topupaccount_form_card"
      >
        <div className="mono_section_title">
          <h2>Topup Account</h2>
        </div>
        <div className="mono_topupaccount_page_content">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="User ID *"
                type="text"
                name="userId"
                placeholder="Enter your user id"
                onChange={(e) => setData({ ...data, userId: e.target.value })}
                className="input_field"
              />
            </div>
            <div className="form_group">
              <Select
                label="Packages *"
                className="select_field"
                value={data.package}
                name="package"
                onChange={(e) => setData({ ...data, package: e.target.value })}
                options={selectOption}
              />
            </div>
            <Button type="submit" className="submit_btn">
              topup id
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default AccountTopupPage;
